<template>
  <div class="detail-2-container">
    <div class="logo-container">
      <div class="go-back-bt" @click="goBack">返回</div>
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/logo.png"
        alt=""
        class="logo"
      />
    </div>

    <div class="photo-container">
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/photo/suqian-louqinjian.png"
        class="photo"
        alt=""
      />
      <div class="names">省委书记娄勤俭</div>
    </div>

    <div class="content-container">
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/yinhao.png"
        class="yinhao-1"
        alt=""
      />
      {{ content }}
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/yinhao.png"
        class="yinhao-2"
        alt=""
      />
    </div>

    <div class="choose-label">
      <div class="point"></div>
      <div>请选择观看模式</div>
      <div class="point"></div>
    </div>

    <div class="mode-select-container">
      <div class="mode">
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/phone-1.png"
          alt=""
          class="p-1"
          @click="goAlone"
        />
        <div class="mode-select-text">单机</div>
      </div>

      <div class="mode">
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/phone-2.png"
          alt=""
          class="p-2"
          @click="goTwoPhone"
        />
        <div class="mode-select-text">双机</div>
        <!-- <div class="mode-select-egg">（十三市书记为您埋下的彩蛋）</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { areaInfoList } from "../data";
export default {
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    // 填数据
    const where = this.$route.params.where;
    const info = areaInfoList[where];
    this.content = info.bigLeaderMsg;
  },
  methods: {
    goBack() {
      this.$router.replace(`/detail/${this.$route.params.where}`);
    },

    goAlone() {
      this.$router.replace(
        `/view-video/${this.$route.params.where}/mid/no-uuid`
      );
    },

    goTwoPhone() {
      this.$router.replace(`/two-phone-qrcode/${this.$route.params.where}`);
    },
  },
};
</script>

<style scoped>
.detail-2-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.logo-container {
  display: flex;
  align-items: flex-end;
}

.go-back-bt {
  width: 61px;
  height: 22px;
  background: #ffde98;
  box-shadow: 0px 3px 17px 0px rgba(146, 5, 0, 0.46);
  border-radius: 11px;

  font-size: 15px;
  color: #990100;
  line-height: 22px;
  text-align: center;
  margin-left: 7vw;
}

.logo {
  margin-right: 4vw;
  margin-left: auto;
  display: block;
  width: 20vw;
}

.photo-container {
  width: 100%;
  margin-top: 20px;
  padding-left: 12vw;
  position: relative;
}

.photo {
  width: 32vw;
  position: relative;
  z-index: 10;
}

.names {
  position: absolute;
  left: 38.67vw;
  top: 15.5vw;
  min-width: 192px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #ffde98;
  font-size: 18px;
  font-family: FZZH;
  background: url("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/name-bg.png");
  background-size: 100% 100%;
  z-index: 5;
}

.content-container {
  width: calc(100% - 64px);
  margin: 22px auto 0;
  padding: 27px 22px 25px 26px;
  background: rgba(123, 0, 0, 0.6);

  /* font-size: 18px; */
  /* line-height: 26px; */
  font-size: 4.8vw;
  line-height: 7vw;
  font-family: FZZH;
  color: #ffde98;
  text-shadow: 0px 3px 12px rgba(93, 3, 0, 0.46);
  position: relative;
  text-align: justify;
}

.yinhao-1 {
  position: absolute;
  left: 30px;
  width: 7.2vw;
  top: 0;
  transform: translateY(-50%);
}

.yinhao-2 {
  position: absolute;
  right: 30px;
  width: 7.2vw;
  bottom: 0;
  transform: rotate(180deg) translateY(-50%);
}

.choose-label {
  margin-top: auto;
  padding: 0 8px;
  width: 150px;
  height: 22px;
  border-radius: 12px;
  background: #ffde98;
  line-height: 22px;
  font-size: 15px;
  color: #990100;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: center;
}

.point {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(153, 1, 0);
}

.mode-select-container {
  margin-top: 23px;
  display: flex;
  justify-content: space-around;
  margin-bottom: auto;
  padding: 0 10%;
}

.mode {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.p-1 {
  width: 15vw;
}

.p-2 {
  width: 30.6vw;
}

.mode-select-text {
  font-size: 16px;
  color: #ffde98;
  margin-top: 10px;
  letter-spacing: 2px;
}

.mode-select-egg {
  color: rgba(255, 222, 152, 0.8);
  font-size: 14px;
  font-weight: 300;
  position: absolute;
  bottom: 0;
  left: 0;
  word-break: keep-all;
  transform: translateY(120%) translateX(-40px);
}

@media screen and (min-width: 640px) {
  .logo {
    margin-right: 40px;
    margin-left: auto;
    display: block;
    width: 128px;
  }

  .photo-container {
    padding-left: 75px;
  }

  .photo {
    width: 200px;
  }

  .names {
    left: 247px;
    top: 100px;
  }

  .content-container {
    font-size: 18px;
    line-height: 26px;
  }

  .yinhao-1 {
    width: 45px;
  }

  .yinhao-2 {
    width: 45px;
  }

  .p-1 {
    width: 96px;
  }

  .p-2 {
    width: 196px;
  }
}
</style>